import type { TOC } from '@ember/component/template-only'
import { type BooksReadRexRoute } from 'teacher-ui-client/reporting/ui-scope/rex/books-read/by-genre/route'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { array } from '@ember/helper'
import { not } from 'ember-truth-helpers'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { BooksReadByGenreTotals } from 'teacher-ui-client/components/giraffe/charts/books-read/by-genre/totals'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { camelize } from '@ember/string'
import { BooksReadByGenreHistory } from 'teacher-ui-client/components/giraffe/charts/books-read/by-genre/history'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<BooksReadRexRoute>
}

export const RexBooksReadByGenre: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.booksReadByGenre.rex"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.booksReadByGenreTotals true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.booksReadByGenreTotals}}>
    {{#each @model.booksReadByGenreTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <BooksReadByGenreTotals
          @data={{gradeData}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.booksReadByGenreTotals"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.booksReadByGenreTotals." (camelize @model.uiScope.scope))}}
          @title={{t "reporting.chartTitles.booksReadByGenreTotals"}}
        />
      </div>
    {{/each}}

    {{#if @model.booksReadByGenreHistory}}
      <div class="my-10">
        <BooksReadByGenreHistory
          @booksReadByGenreData={{@model.booksReadByGenreHistory}}
          @subco={{(isSubco)}}
          @students={{@model.scopedStudents}}
          @uiScope={{@model.uiScope.scope}}
          @tooltip={{t "reporting.tooltips.booksReadByGenreHistory"}}
          @studentRouteName="reporting.ui-scope.rex.student-summary"
        />
      </div>
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexBooksReadByGenre)
